import { useCallback } from 'react';

import { RecoilState, useRecoilState } from 'recoil';

export interface NamedItem {
  name: string;
}

export const useProgress = <T extends NamedItem>(atom: RecoilState<T[]>) => {
  const [items, setItems] = useRecoilState(atom);

  const upsert = useCallback(
    (data: T) => {
      setItems(currentState => {
        const index = currentState.findIndex(item => item.name === data.name);

        if (index >= 0) {
          const updatedItems = [...currentState];
          updatedItems[index] = data;

          return updatedItems;
        }

        return [...currentState, data];
      });
    },
    [setItems],
  );

  const remove = useCallback(
    (data: T) => {
      setItems(currentState => {
        return currentState.filter(item => item.name !== data.name);
      });
    },
    [setItems],
  );

  return {
    items,
    upsert,
    remove,
  };
};
